// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlaySquareFilledSvg from "@ant-design/icons-svg/es/asn/PlaySquareFilled";
import AntdIcon from '../components/AntdIcon';

var PlaySquareFilled = function PlaySquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareFilledSvg
  }));
};

PlaySquareFilled.displayName = 'PlaySquareFilled';
export default React.forwardRef(PlaySquareFilled);